(function ($) {
  $(document).on('keydown', function(e) {
    var keyCode = e.keyCode || e.which;

    if (keyCode == 9) {
      $('body').addClass('accessibility-mode');
    }
  });

})(jQuery);
